import { useContext } from 'react';

import EpisodeListEpisodeRowContext from './EpisodeListEpisodeRowContext';

export default function useEpisodeListEpisodeRowContext() {
  return useContext(EpisodeListEpisodeRowContext);
}
